module.exports = __webpack_public_path__ + "img/404-2@2x.4808ec52.png";